import React from 'react'

import cx from 'classnames'
import { node, string, bool } from 'prop-types'

import styles from './ColumnMain.scss'

const LeftColumn = ({
  children,
  isFullWidth,
  component: Component,
  className
}) => {
  return (
    <Component
      className={cx({
        [styles.columnMain]: true,
        [styles.columnMainFullWidth]: isFullWidth,
        [className]: className
      })}
    >
      {children}
    </Component>
  )
}

LeftColumn.propTypes = {
  children: node,
  component: string,
  isFullWidth: bool,
  className: string
}

LeftColumn.defaultProps = {
  component: 'div',
  isFullWidth: false
}

export default LeftColumn
